import { PropsWithChildren } from "react";
import { AppProps } from "next/app";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "core-js/stable/array/flat-map";
import "core-js/stable/array/flat";
import "@formatjs/intl-numberformat/polyfill";
import "@formatjs/intl-numberformat/locale-data/sv";
import "intersection-observer";
import "global.css";
import { MantineProvider } from "@mantine/core";

import { Datadog } from "@chef/feature-datadog";
import { DiscountsProvider } from "@chef/state-management/components";
import { storeWrapper } from "@chef/state-management";
import { DebugProvider } from "@chef/feature-debug";
import { Notifications } from "@chef/feature-notifications";
import { MobileAppProvider } from "@chef/feature-mobile-app";
import { useOutlineListener } from "@chef/hooks";
import PreviewProvider from "@chef/feature-sanity/PreviewProvider";
import { gtFix } from "@chef/utils/patch";
import { TrackingProvider } from "@chef/smart-components";
import { ModalProvider } from "@chef/feature-modal";

gtFix();

const Providers = ({ children }: PropsWithChildren) => {
  return (
    <MobileAppProvider>
      <TrackingProvider>
        <DiscountsProvider>
          <Datadog />

          <Notifications position="top-center" />
          <ModalProvider />
          <DebugProvider>{children}</DebugProvider>
        </DiscountsProvider>
      </TrackingProvider>
    </MobileAppProvider>
  );
};

function LinasApp({ pageProps, Component, router }: AppProps) {
  useOutlineListener();

  if (router.pathname.startsWith("/studio")) {
    return (
      <MantineProvider>
        <Component {...pageProps} />
      </MantineProvider>
    );
  }

  return (
    <PreviewProvider draftMode={pageProps.draftMode}>
      <Providers>
        <div className="flex flex-col min-h-screen">
          <Component {...pageProps} />
        </div>
      </Providers>
    </PreviewProvider>
  );
}

export default storeWrapper.withRedux(LinasApp);
